import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  handleAPIErrorToast,
  loadingToast,
  successToast,
} from "@/component/toasts";
import { gePreferred, updatePreferredTerms } from "@/services/auth";
import { pluralizePreferredStaffTerm } from "@/utils/preferredTerms";

export const updatePreferredAsync = createAsyncThunk(
  "terms/updateTerms",
  async (data: any) => {
    let response;
    loadingToast("Updating Preferred Terms");
    try {
      response = await updatePreferredTerms(data.userId, data);
      successToast(response.message);
      const staff = pluralizePreferredStaffTerm(response.data.staff);

      return {
        ...response.data,
        staff,
        data: {
          _id: response.data._id,
          userId: response.data.serviceUserId,
          staff,
          serviceUser: response.data.serviceUser,
          care: response.data.care,
        },
      };
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const getPreferredUsersAsync = createAsyncThunk(
  "terms/getTerms",
  async (id: string) => {
    try {
      const response = await gePreferred(id);
      if (!response?.data) return response;

      return {
        ...response,
        data: {
          ...response.data,
          staff: pluralizePreferredStaffTerm(response.data.staff),
        },
      };
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);
